import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { adminApi, apiError } from "@/components/admin/api";
import BookingCard from "@/components/admin/BookingCard";

const FILTERS = [
  { id: "hoje", label: "Hoje" },
  { id: "semana", label: "Semana" },
  { id: "mes", label: "Mês" },
  { id: "aguardando", label: "Aguardando confirmação" },
  { id: "agendadas", label: "Agendadas" },
  { id: "confirmadas", label: "Confirmadas" },
  { id: "realizadas", label: "Realizadas" },
  { id: "canceladas", label: "Canceladas" },
  { id: "faltas", label: "Não compareceu" },
  { id: "todos", label: "Todos" },
];

const BookingsView = ({ onOpenPackage }) => {
  const [filtro, setFiltro] = useState("hoje");
  const [bookings, setBookings] = useState(null);
  const [acting, setActing] = useState(false);

  const load = useCallback(() => {
    let stale = false;
    setBookings(null);
    adminApi
      .get("/admin/journey/bookings", { params: { filtro } })
      .then((res) => { if (!stale) setBookings(res.data); })
      .catch((e) => { if (!stale) toast.error(apiError(e, "Não foi possível carregar os agendamentos.")); });
    return () => { stale = true; };
  }, [filtro]);

  useEffect(load, [load]);

  const onAction = async (protocol, payload) => {
    if (payload.action === "cancelar" && !window.confirm("Cancelar este agendamento?")) return;
    setActing(true);
    try {
      await adminApi.patch(`/admin/journey/bookings/${protocol}`, payload);
      toast.success("Agendamento atualizado.");
      load();
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setActing(false);
    }
  };

  return (
    <div data-testid="agendamentos-view">
      <div className="flex flex-wrap gap-2" data-testid="agendamentos-filtros">
        {FILTERS.map((f) => (
          <button
            key={f.id}
            type="button"
            data-testid={`filtro-${f.id}`}
            onClick={() => setFiltro(f.id)}
            className={`rounded-full border px-4 py-2 text-xs font-medium transition-colors ${
              filtro === f.id ? "border-raiz-800 bg-raiz-800 text-paper" : "border-raiz-800/20 text-raiz-900 hover:border-raiz-800"
            }`}
          >
            {f.label}
          </button>
        ))}
      </div>

      {!bookings ? (
        <div className="mt-8 h-64 animate-pulse rounded-3xl border border-raiz-900/10 bg-cream" data-testid="agendamentos-loading" />
      ) : bookings.length === 0 ? (
        <p className="mt-8 rounded-2xl border border-raiz-900/10 bg-cream p-6 text-sm text-ink/60" data-testid="agendamentos-vazio">
          Nenhum agendamento neste filtro.
        </p>
      ) : (
        <div className="mt-8 space-y-3" data-testid="agendamentos-lista">
          {bookings.map((b) => (
            <BookingCard key={b.protocol} b={b} onAction={onAction} acting={acting} onOpenPackage={onOpenPackage} />
          ))}
        </div>
      )}
    </div>
  );
};

export default BookingsView;
